import { Text } from '@bancobarigui/barihaus';

import { FormLogo } from '@/components/FormLogo';
import { DefinePasswordForm } from './DefinePasswordForm';
import { PublicRouteContainer } from '@/components/PublicRouteContainer';

import { useDefinePassword } from './useDefinePassword';

export default function DefinePassword() {
  const { handleSubmit, loading } = useDefinePassword();

  return (
    <PublicRouteContainer>
      <FormLogo />

      <Text>Bem-vindo! Defina sua senha de acesso:</Text>

      <DefinePasswordForm onFinish={handleSubmit} loading={loading} />
    </PublicRouteContainer>
  );
}
